import { isObj, GetSsApiJwtToken } from "@utils";
import { config } from "@config";

export const fetchCveApi = async function ({ path, method = "GET", query, body, responseObj = true }) {
	try {

		// check for ssapi env variable
		path = path.charAt(0) === "/" ? path : `/${path}`;

		let queryString = "";
		if (typeof query === "string") queryString = query.charAt(0) === "?" ? query : `?${query}`;

		// convert query object to querystring
		if (query && isObj(query)) {
			queryString = `?${new URLSearchParams(query).toString()}`;
		}

		const token = GetSsApiJwtToken();

		let request = {
			method,
			headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
		};
		if (body) request.body = JSON.stringify(body);

		let response = await fetch(`${config.urls.cveApi}${path}${queryString}`, request);

		let data;
		try {
			let newData = await response.json();
			data = newData;
		} catch (error) {}

		if (responseObj) return { status: response.status, ok: response.ok, data };
		return data;
	} catch (error) {
		if (responseObj) return { error };
		return error;
	}
};
